/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentAuthorizationResponse { 
    readonly apiOrderCreationStatus?: PaymentAuthorizationResponse.ApiOrderCreationStatusEnum;
    readonly paymentId?: number;
    readonly dispatchTokenResponse?: string;
    readonly appLinkUri?: string;
    readonly method?: string;
}
export namespace PaymentAuthorizationResponse {
    export const ApiOrderCreationStatusEnum = {
        PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
        WAITING_AUTHORIZATION_CONFIRMATION: 'WAITING_AUTHORIZATION_CONFIRMATION',
        AUTHORIZATION_SUCCEEDED: 'AUTHORIZATION_SUCCEEDED',
        AUTHORIZATION_FAILED: 'AUTHORIZATION_FAILED',
        AUTHORIZATION_EXPIRED: 'AUTHORIZATION_EXPIRED'
    } as const;
    export type ApiOrderCreationStatusEnum = typeof ApiOrderCreationStatusEnum[keyof typeof ApiOrderCreationStatusEnum];
}


